<template>
  <div class="ok-footer leo2-footer-content">
    <div class="footer-box">
      <div class="copyright-bottom">
        <div class="links">
          <b>友情链接：</b>&nbsp;
          <span v-for="(item, index) in list" :key="index">
            <a class="stat_click" :href="item.Url" @click="toStat(item.id)" target="_blank">{{ item.Title }}&nbsp;</a>
            <span v-if="index !== list.length - 1">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          </span>
        </div>
        <div class="links beian">© {{ year }} 珠海弈格网络科技有限公司
          <span class="bq">版权所有</span>
          <a href="http://beian.miit.gov.cn" rel="nofollow" target="_blank">
            {{ record }}
          </a>
          <img src="/static/img/icp.png?v=1">
          <a href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=44040202001855" target="_blank">粤公网安备44040202001855号</a>
        </div>
        <div class="address">联系地址：珠海市香洲区旅游路168号梅溪商业广场2栋22层2201-6
          <a href="/privacy" rel="nofollow" target="_blank">隐私协议</a>
        </div>
      </div>
    </div>
    <div class="code">
      <img src="/static/images/pc/code.png?v=2">
    </div>
  </div>
</template>

<script>
import { Url } from "../utils/config.js";
import { storage } from "../utils/storage.js";
export default {
  name: "ok-footer",
  data() {
    return {
      record: "粤ICP备2026014021号-1",
      list: [],
      year: new Date().getFullYear()
    };
  },
  mounted() {
    // console.log('window.location.href', window.location.host)
    if (window.location.host === Url) {
      this.record = "粤ICP备2026014021号-1";
    } else {
      this.record = "粤ICP备2026014021号-1";
    }

    this.loadData();
  },
  methods: {
    loadData() {
      this.axios.friendLink().then((res) => {
        if (res.data.code === 0) {
          if (res.data.data.length > 0) {
            this.list = res.data.data;
          } else {
            this.list = [];
          }
        } else {
          this.list = [];
        }
      });
    },
    toStat(id) {
      var key = 'friendlink:' + id;
      this.axios.statsClick({ type: 'friendlink', id: id, is_count: !storage.get(key) ? 1 : 0 }).then(() => { });
      storage.set(key, 1);
    }
  },
};
</script>

<style scoped lang="scss">
.leo2-footer-content {
  background: #f5f5f5;
  width: 100%;
  height: 100px;
  font-size: 16px;
  clear: both;

  .footer-box {
    width: 980px;
    margin: 0 auto;
    padding: 0 50px;

    .copyright-bottom {
      clear: both;
      display: block;
      text-align: center;
      padding-top: 10px;
      // padding-bottom: 20px;

      .links {
        clear: both;
        display: block;
        font-size: 16px;
        color: #333 !important;
        line-height: 24px;

        b {
          font-weight: 700;
          line-height: 24px;
        }

        a {
          color: #333;
          text-decoration: none;
        }

        a:hover {
          color: #333;
        }
      }

      .address {
        height: 30px;
        background: #f5f5f5;
        margin-bottom: 10px;
        text-align: center;
        font-size: 16px;
        line-height: 30px;
        color: #333333;
        
        a {
          margin-left: 30px;
          color: #333;
          // text-decoration: underline;
        }

        a:hover {
          margin-left: 30px;
          color: #333;
          // text-decoration: underline;
        }
      }
      .beian {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          height: 16px;
          margin: 0 10px;
          margin-right: 4px;
        }
        .bq{
          margin: 0 4px;
        }
      }
    }
  }
}
.code{
  position: fixed;
  right: 50px;
  bottom: 50px;
  img{
    width: 216px;
    height: 256px;
  }
}
</style>
